/*

    General scripts

*/

// Selects
jQuery('select').on('change', function()
{
	jQuery(this).toggleClass('selected', jQuery(this).val() !== "");
}); 



// WEBPACK FOOTER //
// ./assets/js/components/general.js